module.exports = __webpack_public_path__ + "media/images/background-top-5cc0d067573e7ac24e6f6ec6aba6de0b.jpg";